<template>
<Layout>
    <div class="lg:w-3/4 w-full mx-auto bg-white font-mono text-xs md:text-sm lg:text-base text-left p-2">
        <p class="my-4">
        AMBRA is a contemporary street fashion ready-to-wear label founded in 2019. With a focus on high-level craftsmanship and the silhouettes produced, storytelling is discovered through each piece. Deriving from the eclecticism architectural current and always intersecting with many urban subcultures , creating without boundaries is the foundation of the process.
        </p>
        <p>The vision of AMBRA is that of a figurative look, designed to inspire integrity, attitude, and confidence.
        </p> 
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
    </div>
</Layout>
</template>

<script>
import Layout from '../components/Layout.vue';
export default {
    name: "AboutPage",
    components: {
        Layout
    },
};
</script>
